import { connect } from '../../../../react-redux';
import makeEditable from '../../../shared/functionality/makeEditable';
import { showError, hideError } from '../../../../actions/errorsShowing';
import { screenreaderNotification } from '../../../../actions/alerts';
import { clearNextQuizEntry } from '../../../../actions/modifications';
import EntrySave from './presenter';
export function mapStateToProps(state, props) {
  // Error Related:
  var workingEntry = props.entry.getWorkingInstance();
  var isValid = props.isValid !== void 0 ? props.isValid : workingEntry.isValid();
  return {
    isValid: isValid
  };
}
var mapDispatchToProps = {
  clearNextQuizEntry: clearNextQuizEntry,
  hideError: hideError,
  screenreaderNotification: screenreaderNotification,
  showError: showError
};
export default makeEditable(connect(mapStateToProps, mapDispatchToProps)(EntrySave));